import PropTypes from 'prop-types';

export default PropTypes.shape({
  caseId: PropTypes.string,
  cashCompensationAmount: PropTypes.number,
  cashCompensationPercentage: PropTypes.number,
  compensationRecord: PropTypes.string,
  compensationRecordId: PropTypes.string,
  currency: PropTypes.string,
  delayDurationMins: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  method: PropTypes.string,
  status: PropTypes.string,
  ticketNumber: PropTypes.string,
  ticketPrice: PropTypes.number,
  voucherCompensationAmount: PropTypes.number,
  voucherCompensationPercentage: PropTypes.number
});
